module.exports = __webpack_public_path__ + "static/media/la-icon.29d30268.png";